// removed by extract-text-webpack-plugin
module.exports = {"newsletter":"c-RegisterCustomerClubFields__newsletter"};